import { Link } from 'react-router-dom'

import styles from '../BillingNew.module.scss'
import BillingRowHolder from '../BillingRowHolder'
import { PaymentRow } from '../PaymentRow'

const PaymentsColumn = ({ payments, handleRetryPayment, handlePaymentUpdate }) => {
  return (
    <div className={styles.paymentsColumn}>
      <BillingRowHolder
        title={
          <div className={styles.billingRowTitle}>
            Processed payments
            <Link to="/billing/editBillingInfo" className={styles.billingRowTitleButton}>
              <button>Edit payment methods</button>
            </Link>
          </div>
        }
      >
        {payments &&
          payments.map(p => (
            <PaymentRow
              {...p}
              key={p.paymentAddedOn + p.paymentFriendlyName}
              handleRetry={() => handleRetryPayment(p.id)}
              handleMarkAsPaid={() =>
                handlePaymentUpdate({
                  paymentId: p.id,
                  approvalCode: p.paymentConfirmationCode,
                  paymentProcessedBy: p.paymentProcessedBy,
                  processorStatus: 'Success'
                })
              }
              handleMarkAsRejected={() =>
                handlePaymentUpdate({
                  paymentId: p.id,
                  approvalCode: p.paymentConfirmationCode,
                  paymentProcessedBy: p.paymentProcessedBy,
                  processorStatus: 'Declined'
                })
              }
            />
          ))}
      </BillingRowHolder>
    </div>
  )
}

export default PaymentsColumn
